// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar .fc-button-primary {
  background-color: #ffe850;
  border: none;
  color: #222;
}

.calendar .fc-toolbar-title {
  text-transform: capitalize;
}

.calendar .fc-button-primary:hover {
  background-color: #ffde00;
  border: none;
}

.calendar .fc-toolbar-chunk {
  flex: 0 0 33.333333%;
  width: 33.3333333%;
}

.calendar .fc-toolbar-chunk:nth-child(2) {
  text-align: center;
}

.calendar .fc-toolbar-chunk:nth-child(3) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.calendar .fc-direction-ltr .fc-daygrid-week-number {
  background-color: transparent;
  font-size: 0.7rem;
  text-decoration: none;
  position: absolute;
  top: 3px;
  left: 0
}

.calendar .fc-scrollgrid-sync-table {
  /*  height: auto !important; */
}

.calendar .fc-daygrid-event {}


.calendar .fc-daygrid-event-harness {

  font-size: 0.9rem;
  max-width: 100%;
  overflow: hidden;


}

.calendar .fc .fc-daygrid-body-balanced .fc-daygrid-day-events {
  position: relative;

}

.calendar .fc-theme-standard td,
.calendar .fc-theme-standard th {
  height: 2px;
}


.calendar .fc-direction-ltr .fc-daygrid-event.fc-event-end,
.calendar .fc-direction-rtl .fc-daygrid-event.fc-event-start {
  /* margin-right: 0; */
}


.calendar .fc .fc-daygrid-day.fc-day-today {
  background-color: transparent;


}

.calendar .fc .fc-daygrid-day-number {


  /*
    font-size: 0.75rem;
  
  padding-bottom: 3px;
  padding-top: 2px;
  font-weight: bold;
  line-height: 1;
  */
  text-decoration: none;
  width: 20px;
  line-height: 20px;
  padding: 0 !important;
  margin-top: 3px;

  text-align: center;

  font-size: 0.70rem;
}

.calendar .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  background-color: #ffe850;

  border-radius: 50%;


}

.calendar .fc .fc-daygrid-day-top {
  justify-content: center;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/css/calendar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;;;AAG7B;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;;AAGlB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;;EAEE,WAAW;AACb;;;AAGA;;EAEE,qBAAqB;AACvB;;;AAGA;EACE,6BAA6B;;;AAG/B;;AAEA;;;EAGE;;;;;;;GAOC;EACD,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;;EAEf,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;;EAEzB,kBAAkB;;;AAGpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".calendar .fc-button-primary {\r\n  background-color: #ffe850;\r\n  border: none;\r\n  color: #222;\r\n}\r\n\r\n.calendar .fc-toolbar-title {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.calendar .fc-button-primary:hover {\r\n  background-color: #ffde00;\r\n  border: none;\r\n}\r\n\r\n.calendar .fc-toolbar-chunk {\r\n  flex: 0 0 33.333333%;\r\n  width: 33.3333333%;\r\n}\r\n\r\n.calendar .fc-toolbar-chunk:nth-child(2) {\r\n  text-align: center;\r\n}\r\n\r\n.calendar .fc-toolbar-chunk:nth-child(3) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.calendar .fc-direction-ltr .fc-daygrid-week-number {\r\n  background-color: transparent;\r\n  font-size: 0.7rem;\r\n  text-decoration: none;\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 0\r\n}\r\n\r\n.calendar .fc-scrollgrid-sync-table {\r\n  /*  height: auto !important; */\r\n}\r\n\r\n.calendar .fc-daygrid-event {}\r\n\r\n\r\n.calendar .fc-daygrid-event-harness {\r\n\r\n  font-size: 0.9rem;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n\r\n\r\n}\r\n\r\n.calendar .fc .fc-daygrid-body-balanced .fc-daygrid-day-events {\r\n  position: relative;\r\n\r\n}\r\n\r\n.calendar .fc-theme-standard td,\r\n.calendar .fc-theme-standard th {\r\n  height: 2px;\r\n}\r\n\r\n\r\n.calendar .fc-direction-ltr .fc-daygrid-event.fc-event-end,\r\n.calendar .fc-direction-rtl .fc-daygrid-event.fc-event-start {\r\n  /* margin-right: 0; */\r\n}\r\n\r\n\r\n.calendar .fc .fc-daygrid-day.fc-day-today {\r\n  background-color: transparent;\r\n\r\n\r\n}\r\n\r\n.calendar .fc .fc-daygrid-day-number {\r\n\r\n\r\n  /*\r\n    font-size: 0.75rem;\r\n  \r\n  padding-bottom: 3px;\r\n  padding-top: 2px;\r\n  font-weight: bold;\r\n  line-height: 1;\r\n  */\r\n  text-decoration: none;\r\n  width: 20px;\r\n  line-height: 20px;\r\n  padding: 0 !important;\r\n  margin-top: 3px;\r\n\r\n  text-align: center;\r\n\r\n  font-size: 0.70rem;\r\n}\r\n\r\n.calendar .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {\r\n  background-color: #ffe850;\r\n\r\n  border-radius: 50%;\r\n\r\n\r\n}\r\n\r\n.calendar .fc .fc-daygrid-day-top {\r\n  justify-content: center;\r\n  flex-direction: row;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
